<app-sidebar></app-sidebar>
<app-header></app-header>
<div class="content-wrapper">
    <ngx-spinner type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="card text-center">
        <div class="col-md-12 no-print sticky">
            <div class="card">
                <div class="row justify-content-md-center" style="margin-top: 25px;">
                    <div class="col-md-auto">
                        <mat-form-field class="example-full-width" appearance="fill">
                            <mat-label>--เลขกลุ่มตัด--</mat-label>
                            <input type="text" matInput placeholder="ระบุเลขกลุ่มตัด" value="" maxlength="8"
                                id="groupCode" [(ngModel)]="groupCode">
                        </mat-form-field>
                        <!--<p>
                            <mat-form-field appearance="fill">
                                <mat-label>เลือกวันที่ </mat-label>
                                <input matInput [matDatepicker]="dp3" [(ngModel)]="date2d"
                                    (ngModelChange)="Loaddata1()">
                                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                            </mat-form-field>
                        </p>-->
                    </div>
                    <div class="col-md-auto">
                        <button mat-raised-button color="primary" [disabled]="!groupCode"
                            (click)="Loaddata2()">ค้นหา</button>
                    </div>

                    <div class="col-lg-2" *ngIf="dataApi0.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกชาวไร่</mat-label>
                            <mat-select disableRipple required multiple [(ngModel)]="selectS"
                                (selectionChange)="filter_data2()">
                                <mat-option *ngFor="let item of dataApi0" [value]="item">
                                    {{item.fmname}} | แปลงตัดเสร็จ-{{item.cntF}}/{{item.cnt}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-auto" *ngIf="selectS.length > 0">
                        <div class="button-row">
                            <button mat-raised-button color="accent" [disabled]="edit_st != 0"
                                *ngIf="selectS.length > 0" (click)="printPage()"><mat-icon> print
                                </mat-icon></button>&nbsp;
                            <!--<button mat-raised-button color="primary" [disabled]="edit_st != 0"
                                (click)="selectS=0"><mat-icon>restart_alt</mat-icon></button>-->
                        </div>
                    </div>
                </div>
                <div class="text-center" *ngIf="selectS.length > 0">
                    <div class="btn-group mr-2" role="group" aria-label="Basic example" *ngFor="let fm of g_farmer">
                        <button type="button" class="btn btn-outline-danger btn-sm"
                            (click)="scrollTo(fm)">{{fm}}</button>
                    </div>

                </div>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-md-10">
                <div class="card" style="page-break-inside: avoid;" *ngFor="let dt of selectS">
                    <div class="card-header" id="{{dt.fmname}}">
                        <div class="text-center">
                            <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO">
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row" style="align-content: center;">
                            <p style="text-align:center; font-size:24px"> <b>
                                    <u>รายงานผลผลิต {{yearN.yearDesc}}</u>
                                </b></p>

                            <p style="text-align:center; font-size:20px"><b>ชื่อ</b>
                                &nbsp;<span class="border border-primary"> {{ dt.fmname }}</span>&nbsp;
                                <b>เลขบัญชี</b> &nbsp;<span class="border border-primary"> {{dt.fmcode }} </span>&nbsp;
                            </p>

                            <p style="text-align:center; font-size:20px"><b>ปริมาณตันเป้าหมาย</b>
                                &nbsp;<span class="border border-primary">{{ dt.Assess|number}}</span>&nbsp; <b>ตัน</b>
                            </p>

                            <p style="text-align:center; font-size:20px"><b>ผลผลิตเป้าหมาย</b>
                                &nbsp;<span class="border border-primary">{{ dt.Ton |number}}</span>&nbsp;
                                <b>ตัน/ไร่</b>
                            </p>

                            <div class="row justify-content-md-center">
                                <div class="col-md-8">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr class="table-info" style="text-align: center;">
                                                <th></th>
                                                <th>พื้นที่(ไร่)</th>
                                                <th>ผลผลิต(ตัน/ไร่)</th>
                                                <th>ประเมิน(ตัน)</th>
                                            </tr>
                                        </thead>
                                        <tbody class="table-group-divider">
                                            <tr>
                                                <td>ER</td>
                                                <td>{{dt.landvalue_er| number:'1.2-2' }}</td>
                                                <td>{{dt.yield_er | number:'1.2-2' }}</td>
                                                <td>{{dt.Assess_er | number:'1.2-2' }}</td>
                                            </tr>
                                            <tr>
                                                <td>ST</td>
                                                <td>{{dt.landvalue_st| number:'1.2-2' }}</td>
                                                <td>{{dt.yield_st | number:'1.2-2' }}</td>
                                                <td>{{dt.Assess_st | number:'1.2-2' }}</td>
                                            </tr>
                                            <tr>
                                                <td>SR</td>
                                                <td>{{dt.landvalue_sr| number:'1.2-2' }}</td>
                                                <td>{{dt.yield_sr | number:'1.2-2' }}</td>
                                                <td>{{dt.Assess_sr | number:'1.2-2' }}</td>
                                            </tr>
                                            <tr class="table-secondary">
                                                <td>รวม</td>
                                                <td>{{dt.landvalue| number:'1.2-2' }}</td>
                                                <td>{{dt.Ton | number:'1.2-2' }}</td>
                                                <td>{{dt.Assess | number:'1.2-2' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <div class="card" style="border:black; border-width:2px; border-style:solid;">
                                <div class="card-header">
                                    <h3><b><u>รายงานผลผลิตแปลงตัดเสร็จ</u></b></h3>
                                </div>
                                <table class="card-body table table-bordered">
                                    <thead>
                                        <tr style="text-align: center;">
                                            <th [rowSpan]="2"></th>
                                            <th [colSpan]="3">ประเมิน</th>
                                            <th [colSpan]="2">ตัดเสร็จเข้าหีบ</th>
                                            <th></th>
                                        </tr>
                                        <tr class="table-info" style="text-align: center;">
                                            <th>พื้นที่(ไร่)</th>
                                            <th>ผลผลิต(ตัน/ไร่)</th>
                                            <th>ประเมิน(ตัน)</th>
                                            <th>ผลผลิต(ตัน/ไร่)</th>
                                            <th>เข้าหีบ(ตัน)</th>
                                            <th>เทียบประเมิน(%)</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                        <tr>
                                            <td>ER</td>
                                            <td>{{dt.landvalue_erf | number:'1.2-2' }}</td>
                                            <td>{{dt.yield_erf | number:'1.2-2' }}</td>
                                            <td>{{dt.Assess_erf | number:'1.2-2' }}</td>
                                            <td>{{dt.yields_erf | number:'1.2-2' }}</td>
                                            <td>{{dt.canein_er | number:'1.2-2' }}</td>
                                            <td>{{calPercent(dt.Assess_erf,dt.canein_er) | number:'1.2-2' }}</td>
                                        </tr>
                                        <tr>
                                            <td>ST</td>
                                            <td>{{dt.landvalue_stf | number:'1.2-2' }}</td>
                                            <td>{{dt.yield_stf | number:'1.2-2' }}</td>
                                            <td>{{dt.Assess_stf | number:'1.2-2' }}</td>
                                            <td>{{dt.yields_stf | number:'1.2-2' }}</td>
                                            <td>{{dt.canein_st | number:'1.2-2' }}</td>
                                            <td>{{calPercent(dt.Assess_stf,dt.canein_st) | number:'1.2-2' }}</td>
                                        </tr>
                                        <tr>
                                            <td>SR</td>
                                            <td>{{dt.landvalue_srf | number:'1.2-2' }}</td>
                                            <td>{{dt.yield_srf | number:'1.2-2' }}</td>
                                            <td>{{dt.Assess_srf | number:'1.2-2' }}</td>
                                            <td>{{dt.yields_srf | number:'1.2-2' }}</td>
                                            <td>{{dt.canein_sr | number:'1.2-2' }}</td>
                                            <td>{{calPercent(dt.Assess_srf,dt.canein_sr) | number:'1.2-2' }}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td>รวม</td>
                                            <td>{{dt.landvalueF | number:'1.2-2' }}</td>
                                            <td>{{dt.TonF | number:'1.2-2' }}</td>
                                            <td>{{dt.AssessF | number:'1.2-2' }}</td>
                                            <td>{{dt.yields_f | number:'1.2-2' }}</td>
                                            <td>{{dt.canein_f | number:'1.2-2' }}</td>
                                            <td>{{calPercent(dt.AssessF,dt.canein_f) | number:'1.2-2' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <span class="d-inline-flex p-2"> ณ วันที่ {{todaydate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>